import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faCircleCheck, faSquareCheck } from '@ng-icons/font-awesome/regular';
import { faSolidCircleCheck, faSolidCircleXmark, faSolidSquareCheck, faSolidSquareXmark } from '@ng-icons/font-awesome/solid';
import { Chance } from 'chance';

@Component({
    selector: 'app-answer-item',
    imports: [NgIcon, NgClass],
    templateUrl: './answer-item.component.html',
    styleUrl: './answer-item.component.scss',
    providers: [provideIcons({ faSolidCircleCheck, faCircleCheck, faSolidCircleXmark, faSolidSquareCheck, faSquareCheck, faSolidSquareXmark })]
})
export class AnswerItemComponent {
  @Input()
  isCorrect: boolean = false;

  @Input()
  isHit: boolean = false;

  @Input()
  index: number = 1;

  @Input()
  value: string = '';

  @Input()
  correctCount?: number;

  @Input()
  id: string = new Chance().string({length: 8});
}
